export const SITE = {
  name: "SONOCO EVENTS",
  baseline: "Production technique événementielle",
  url: "https://www.sonocoevents.com",
  email: "contact@sonocoevents.com",
  phones: ["+33 6 84 03 82 69"],
  location: "Fréjus — Var, France",
  instagram: "https://www.instagram.com/sonocoevents",
  ogImage: "/og-image.jpg",
};

export const NAV = [
  { n: "01", label: "Accueil", path: "/" },
  { n: "02", label: "Expertises", path: "/expertises" },
  { n: "03", label: "Réalisations", path: "/realisations" },
  { n: "04", label: "À propos", path: "/a-propos" },
  { n: "05", label: "Contact", path: "/contact" },
];

export const slugify = (s: string) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/&/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
